var skillData=
[
	{
		"id": 301,
		"type": 0,
		"school": 3,
		"icon": 1101,
		"describe": "【猛击】",
		"command": "/技能 猛击"
	},
	{
		"id": 302,
		"type": 0,
		"school": 3,
		"icon": 1104,
		"describe": "【扫荡】",
		"command": "/技能 扫荡"
	},
	{
		"id": 303,
		"type": 0,
		"school": 3,
		"icon": 1105,
		"describe": "【破阵】",
		"command": "/技能 破阵"
	},
	{
		"id": 304,
		"type": 0,
		"school": 3,
		"icon": 1103,
		"describe": "【旋斩】",
		"command": "/技能 旋斩"
	},
	{
		"id": 305,
		"type": 0,
		"school": 3,
		"icon": 1103,
		"describe": "【旋斩二斩】",
		"command": "/技能 旋斩二斩"
	},
	{
		"id": 306,
		"type": 0,
		"school": 3,
		"icon": 1112,
		"describe": "【定军】",
		"command": "/技能 定军"
	},
	{
		"id": 307,
		"type": 0,
		"school": 3,
		"icon": 1102,
		"describe": "【降世】",
		"command": "/技能 降世"
	},
	{
		"id": 308,
		"type": 0,
		"school": 3,
		"icon": 11151,
		"describe": "【罡体】",
		"command": "/技能 罡体"
	},
	{
		"id": 309,
		"type": 0,
		"school": 3,
		"icon": 1123,
		"describe": "【雷罡体】",
		"command": "/技能 雷罡体"
	},
	{
		"id": 310,
		"type": 0,
		"school": 3,
		"icon": 1111,
		"describe": "【龙握】",
		"command": "/技能 龙握"
	},
	{
		"id": 311,
		"type": 0,
		"school": 3,
		"icon": 1113,
		"describe": "【铁血】",
		"command": "/技能 铁血"
	},
	{
		"id": 312,
		"type": 0,
		"school": 3,
		"icon": 1116,
		"describe": "【啸天】",
		"command": "/技能 啸天"
	},
	{
		"id": 313,
		"type": 0,
		"school": 3,
		"icon": 1106,
		"describe": "【光盾】",
		"command": "/技能 光盾"
	},
	{
		"id": 314,
		"type": 0,
		"school": 3,
		"icon": 1106,
		"describe": "【光盾二斩】",
		"command": "/技能 光盾二斩"
	},
	{
		"id": 315,
		"type": 0,
		"school": 3,
		"icon": 1114,
		"describe": "【无畏】",
		"command": "/技能 无畏"
	},
	{
		"id": 316,
		"type": 0,
		"school": 3,
		"icon": 1145,
		"describe": "【飞雷·断】",
		"command": "/技能 飞雷·断"
	},
	{
		"id": 317,
		"type": 0,
		"school": 3,
		"icon": 1141,
		"describe": "【炎雷·转】",
		"command": "/技能 炎雷·转"
	},
	{
		"id": 318,
		"type": 0,
		"school": 3,
		"icon": 1143,
		"describe": "【奔雷·冲】",
		"command": "/技能 奔雷·冲"
	},
	{
		"id": 319,
		"type": 0,
		"school": 3,
		"icon": 1144,
		"describe": "【雷神·千裂破】",
		"command": "/技能 雷神·千裂破"
	},
	{
		"id": 320,
		"type": 0,
		"school": 3,
		"icon": 1162,
		"describe": "【撼·雷霆】",
		"command": "/技能 撼·雷霆"
	},
	{
		"id": 321,
		"type": 0,
		"school": 3,
		"icon": 1163,
		"describe": "【锁·擒魔】",
		"command": "/技能 锁·擒魔"
	},
	{
		"id": 322,
		"type": 0,
		"school": 3,
		"icon": 1161,
		"describe": "【霸·罡体】",
		"command": "/技能 霸·罡体"
	},
	{
		"id": 323,
		"type": 0,
		"school": 3,
		"icon": 1167,
		"describe": "【雷神·绝对守护】",
		"command": "/技能 雷神·绝对守护"
	},
	{
		"id": 324,
		"type": 0,
		"school": 3,
		"icon": 1164,
		"describe": "【惊雷·震万钧】",
		"command": "/技能 惊雷·震万钧"
	},
	{
		"id": 325,
		"type": 0,
		"school": 3,
		"icon": 1146,
		"describe": "【冲雷·降天罡】",
		"command": "/技能 冲雷·降天罡"
	},
	{
		"id": 401,
		"type": 0,
		"school": 4,
		"icon": 1201,
		"describe": "【穿云】",
		"command": "/技能 穿云"
	},
	{
		"id": 402,
		"type": 0,
		"school": 4,
		"icon": 1203,
		"describe": "【流火】",
		"command": "/技能 流火"
	},
	{
		"id": 403,
		"type": 0,
		"school": 4,
		"icon": 1203,
		"describe": "【流火二斩】",
		"command": "/技能 流火二斩"
	},
	{
		"id": 404,
		"type": 0,
		"school": 4,
		"icon": 1206,
		"describe": "【冰封】",
		"command": "/技能 冰封"
	},
	{
		"id": 405,
		"type": 0,
		"school": 4,
		"icon": 1206,
		"describe": "【冰封二斩】",
		"command": "/技能 冰封二斩"
	},
	{
		"id": 406,
		"type": 0,
		"school": 4,
		"icon": 1225,
		"describe": "【聚灵】",
		"command": "/技能 聚灵"
	},
	{
		"id": 407,
		"type": 0,
		"school": 4,
		"icon": 1226,
		"describe": "【火元灵】",
		"command": "/技能 火元灵"
	},
	{
		"id": 408,
		"type": 0,
		"school": 4,
		"icon": 1227,
		"describe": "【冰元灵】",
		"command": "/技能 冰元灵"
	},
	{
		"id": 409,
		"type": 0,
		"school": 4,
		"icon": 1228,
		"describe": "【雷元灵】",
		"command": "/技能 雷元灵"
	},
	{
		"id": 410,
		"type": 0,
		"school": 4,
		"icon": 1204,
		"describe": "【灵袭】",
		"command": "/技能 灵袭"
	},
	{
		"id": 411,
		"type": 0,
		"school": 4,
		"icon": 1202,
		"describe": "【骤雷】",
		"command": "/技能 骤雷"
	},
	{
		"id": 412,
		"type": 0,
		"school": 4,
		"icon": 1202,
		"describe": "【骤雷二斩】",
		"command": "/技能 骤雷二斩"
	},
	{
		"id": 413,
		"type": 0,
		"school": 4,
		"icon": 1213,
		"describe": "【伐·星落】",
		"command": "/技能 伐·星落"
	},
	{
		"id": 414,
		"type": 0,
		"school": 4,
		"icon": 1212,
		"describe": "【定·星阵】",
		"command": "/技能 定·星阵"
	},
	{
		"id": 415,
		"type": 0,
		"school": 4,
		"icon": 1212,
		"describe": "【定·星阵二斩】",
		"command": "/技能 定·星阵二斩"
	},
	{
		"id": 416,
		"type": 0,
		"school": 4,
		"icon": 1212,
		"describe": "【定·星阵三斩】",
		"command": "/技能 定·星阵三斩"
	},
	{
		"id": 417,
		"type": 0,
		"school": 4,
		"icon": 1212,
		"describe": "【定·星阵四斩】",
		"command": "/技能 定·星阵四斩"
	},
	{
		"id": 418,
		"type": 0,
		"school": 4,
		"icon": 1216,
		"describe": "【佑·星体】",
		"command": "/技能 佑·星体"
	},
	{
		"id": 419,
		"type": 0,
		"school": 4,
		"icon": 1211,
		"describe": "【遁·流星】",
		"command": "/技能 遁·流星"
	},
	{
		"id": 420,
		"type": 0,
		"school": 4,
		"icon": 1214,
		"describe": "【裁·星剑】",
		"command": "/技能 裁·星剑"
	},
	{
		"id": 421,
		"type": 0,
		"school": 4,
		"icon": 1214,
		"describe": "【裁·星剑二斩】",
		"command": "/技能 裁·星剑二斩"
	},
	{
		"id": 422,
		"type": 0,
		"school": 4,
		"icon": 1215,
		"describe": "【临·星盾】",
		"command": "/技能 临·星盾"
	},
	{
		"id": 423,
		"type": 0,
		"school": 4,
		"icon": 1215,
		"describe": "【临·星盾二斩】",
		"command": "/技能 临·星盾二斩"
	},
	{
		"id": 424,
		"type": 0,
		"school": 4,
		"icon": 1244,
		"describe": "【万象·剑罚】",
		"command": "/技能 万象·剑罚"
	},
	{
		"id": 425,
		"type": 0,
		"school": 4,
		"icon": 1241,
		"describe": "【焚天·剑舞】",
		"command": "/技能 焚天·剑舞"
	},
	{
		"id": 426,
		"type": 0,
		"school": 4,
		"icon": 1243,
		"describe": "【离火·剑影】",
		"command": "/技能 离火·剑影"
	},
	{
		"id": 427,
		"type": 0,
		"school": 4,
		"icon": 1242,
		"describe": "【天火玄冰坠】",
		"command": "/技能 天火玄冰坠"
	},
	{
		"id": 428,
		"type": 0,
		"school": 4,
		"icon": 1263,
		"describe": "【星刃·闪】",
		"command": "/技能 星刃·闪"
	},
	{
		"id": 429,
		"type": 0,
		"school": 4,
		"icon": 1264,
		"describe": "【御风·流】",
		"command": "/技能 御风·流"
	},
	{
		"id": 430,
		"type": 0,
		"school": 4,
		"icon": 1262,
		"describe": "【虚空·禁】",
		"command": "/技能 虚空·禁"
	},
	{
		"id": 431,
		"type": 0,
		"school": 4,
		"icon": 1261,
		"describe": "【霜月锁千秋】",
		"command": "/技能 霜月锁千秋"
	},
	{
		"id": 432,
		"type": 0,
		"school": 4,
		"icon": 1230,
		"describe": "【霜月锁千秋二斩】",
		"command": "/技能 霜月锁千秋二斩"
	},
	{
		"id": 433,
		"type": 0,
		"school": 4,
		"icon": 1265,
		"describe": "【星流幻空影】",
		"command": "/技能 星流幻空影"
	},
	{
		"id": 434,
		"type": 0,
		"school": 4,
		"icon": 12451,
		"describe": "【苍摇玄天雷】",
		"command": "/技能 苍摇玄天雷 "
	},
	{
		"id": 501,
		"type": 0,
		"school": 5,
		"icon": 1301,
		"describe": "【斩风】",
		"command": "/技能 斩风"
	},
	{
		"id": 502,
		"type": 0,
		"school": 5,
		"icon": 1301,
		"describe": "【斩风二斩】",
		"command": "/技能 斩风二斩"
	},
	{
		"id": 503,
		"type": 0,
		"school": 5,
		"icon": 1301,
		"describe": "【斩风三斩】",
		"command": "/技能 斩风三斩"
	},
	{
		"id": 504,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀】",
		"command": "/技能 狂杀"
	},
	{
		"id": 505,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀二斩】",
		"command": "/技能 狂杀二斩"
	},
	{
		"id": 506,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀三斩】",
		"command": "/技能 狂杀三斩"
	},
	{
		"id": 507,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀四斩】",
		"command": "/技能 狂杀四斩"
	},
	{
		"id": 508,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀五斩】",
		"command": "/技能 狂杀五斩"
	},
	{
		"id": 509,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀六斩】",
		"command": "/技能 狂杀六斩"
	},
	{
		"id": 510,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀七斩】",
		"command": "/技能 狂杀七斩"
	},
	{
		"id": 511,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀八斩】",
		"command": "/技能 狂杀八斩"
	},
	{
		"id": 512,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀九斩】",
		"command": "/技能 狂杀九斩"
	},
	{
		"id": 513,
		"type": 0,
		"school": 5,
		"icon": 1304,
		"describe": "【狂杀最终斩】",
		"command": "/技能 狂杀最终斩"
	},
	{
		"id": 514,
		"type": 0,
		"school": 5,
		"icon": 1313,
		"describe": "【斩青云】",
		"command": "/技能 斩青云"
	},
	{
		"id": 515,
		"type": 0,
		"school": 5,
		"icon": 1303,
		"describe": "【战意诀】",
		"command": "/技能 战意诀"
	},
	{
		"id": 516,
		"type": 0,
		"school": 5,
		"icon": 1317,
		"describe": "【战意之姿】",
		"command": "/技能 战意之姿"
	},
	{
		"id": 517,
		"type": 0,
		"school": 5,
		"icon": 1319,
		"describe": "【破空斩】",
		"command": "/技能 破空斩"
	},
	{
		"id": 518,
		"type": 0,
		"school": 5,
		"icon": 1316,
		"describe": "【破影】",
		"command": "/技能 破影"
	},
	{
		"id": 519,
		"type": 0,
		"school": 5,
		"icon": 1316,
		"describe": "【破影二斩】",
		"command": "/技能 破影二斩"
	},
	{
		"id": 520,
		"type": 0,
		"school": 5,
		"icon": 1316,
		"describe": "【破影三斩】",
		"command": "/技能 破影三斩"
	},
	{
		"id": 521,
		"type": 0,
		"school": 5,
		"icon": 1316,
		"describe": "【破影四斩】",
		"command": "/技能 破影四斩"
	},
	{
		"id": 522,
		"type": 0,
		"school": 5,
		"icon": 1302,
		"describe": "【追命】",
		"command": "/技能 追命"
	},
	{
		"id": 523,
		"type": 0,
		"school": 5,
		"icon": 1302,
		"describe": "【追命二斩】",
		"command": "/技能 追命二斩"
	},
	{
		"id": 524,
		"type": 0,
		"school": 5,
		"icon": 1314,
		"describe": "【不动山】",
		"command": "/技能 不动山"
	},
	{
		"id": 525,
		"type": 0,
		"school": 5,
		"icon": 1314,
		"describe": "【不动山反击】",
		"command": "/技能 不动山反击"
	},
	{
		"id": 526,
		"type": 0,
		"school": 5,
		"icon": 1311,
		"describe": "【定风波】",
		"command": "/技能 定风波"
	},
	{
		"id": 527,
		"type": 0,
		"school": 5,
		"icon": 1311,
		"describe": "【定风波二斩】",
		"command": "/技能 定风波二斩"
	},
	{
		"id": 528,
		"type": 0,
		"school": 5,
		"icon": 1312,
		"describe": "【破月】",
		"command": "/技能 破月"
	},
	{
		"id": 529,
		"type": 0,
		"school": 5,
		"icon": 1305,
		"describe": "【猎光】",
		"command": "/技能 猎光"
	},
	{
		"id": 530,
		"type": 0,
		"school": 5,
		"icon": 1306,
		"describe": "【血绽诀】",
		"command": "/技能 血绽诀"
	},
	{
		"id": 531,
		"type": 0,
		"school": 5,
		"icon": 1345,
		"describe": "【瞬杀·暗月】",
		"command": "/技能 瞬杀·暗月"
	},
	{
		"id": 532,
		"type": 0,
		"school": 5,
		"icon": 1347,
		"describe": "【凌杀·飞羽】",
		"command": "/技能 凌杀·飞羽"
	},
	{
		"id": 533,
		"type": 0,
		"school": 5,
		"icon": 1340,
		"describe": "【闪杀·幻刃】",
		"command": "/技能 闪杀·幻刃"
	},
	{
		"id": 534,
		"type": 0,
		"school": 5,
		"icon": 1342,
		"describe": "【千刃·散浮华】",
		"command": "/技能 千刃·散浮华"
	},
	{
		"id": 535,
		"type": 0,
		"school": 5,
		"icon": 1362,
		"describe": "【斩风雷】",
		"command": "/技能 斩风雷"
	},
	{
		"id": 536,
		"type": 0,
		"school": 5,
		"icon": 1361,
		"describe": "【斩流火】",
		"command": "/技能 斩流火"
	},
	{
		"id": 537,
		"type": 0,
		"school": 5,
		"icon": 1343,
		"describe": "【斩晴空】",
		"command": "/技能 斩晴空"
	},
	{
		"id": 538,
		"type": 0,
		"school": 5,
		"icon": 1343,
		"describe": "【斩晴空二斩】",
		"command": "/技能 斩晴空二斩"
	},
	{
		"id": 539,
		"type": 0,
		"school": 5,
		"icon": 1346,
		"describe": "【灭魄·封神斩】",
		"command": "/技能 灭魄·封神斩"
	},
	{
		"id": 540,
		"type": 0,
		"school": 5,
		"icon": 1363,
		"describe": "【断情·月轮斩】",
		"command": "/技能 断情·月轮斩"
	},
	{
		"id": 541,
		"type": 0,
		"school": 5,
		"icon": 1344,
		"describe": "【疾杀·碎惊风】",
		"command": "/技能 疾杀·碎惊风"
	},
	{
		"id": 601,
		"type": 0,
		"school": 6,
		"icon": 1501,
		"describe": "【疾风弹】",
		"command": "/技能 疾风弹"
	},
	{
		"id": 602,
		"type": 0,
		"school": 6,
		"icon": 1503,
		"describe": "【震荡弹】",
		"command": "/技能 震荡弹"
	},
	{
		"id": 603,
		"type": 0,
		"school": 6,
		"icon": 1512,
		"describe": "【震地雷】",
		"command": "/技能 震地雷"
	},
	{
		"id": 604,
		"type": 0,
		"school": 6,
		"icon": 1504,
		"describe": "【黯灭弹】",
		"command": "/技能 黯灭弹"
	},
	{
		"id": 605,
		"type": 0,
		"school": 6,
		"icon": 1502,
		"describe": "【穿云弹】",
		"command": "/技能 穿云弹"
	},
	{
		"id": 606,
		"type": 0,
		"school": 6,
		"icon": 1513,
		"describe": "【螺旋刃】",
		"command": "/技能 螺旋刃"
	},
	{
		"id": 607,
		"type": 0,
		"school": 6,
		"icon": 1505,
		"describe": "【狙杀模式】",
		"command": "/技能 狙杀模式"
	},
	{
		"id": 608,
		"type": 0,
		"school": 6,
		"icon": 1519,
		"describe": "【炎光傀儡】",
		"command": "/技能 炎光傀儡"
	},
	{
		"id": 609,
		"type": 0,
		"school": 6,
		"icon": 1511,
		"describe": "【暗诡雷】",
		"command": "/技能 暗诡雷"
	},
	{
		"id": 610,
		"type": 0,
		"school": 6,
		"icon": 1511,
		"describe": "【暗诡雷二斩】",
		"command": "/技能 暗诡雷二斩"
	},
	{
		"id": 611,
		"type": 0,
		"school": 6,
		"icon": 1517,
		"describe": "【烈性炸药】",
		"command": "/技能 烈性炸药"
	},
	{
		"id": 612,
		"type": 0,
		"school": 6,
		"icon": 1518,
		"describe": "【寒性炸药】",
		"command": "/技能 寒性炸药"
	},
	{
		"id": 613,
		"type": 0,
		"school": 6,
		"icon": 1514,
		"describe": "【魔能甲】",
		"command": "/技能 魔能甲"
	},
	{
		"id": 614,
		"type": 0,
		"school": 6,
		"icon": 1514,
		"describe": "【魔能甲二斩】",
		"command": "/技能 魔能甲二斩"
	},
	{
		"id": 615,
		"type": 0,
		"school": 6,
		"icon": 1506,
		"describe": "【死亡标记】",
		"command": "/技能 死亡标记"
	},
	{
		"id": 616,
		"type": 0,
		"school": 6,
		"icon": 1515,
		"describe": "【聚能】",
		"command": "/技能 聚能"
	},
	{
		"id": 617,
		"type": 0,
		"school": 6,
		"icon": 1541,
		"describe": "【死亡狙击】",
		"command": "/技能 死亡狙击"
	},
	{
		"id": 618,
		"type": 0,
		"school": 6,
		"icon": 1542,
		"describe": "【杀戮风暴】",
		"command": "/技能 杀戮风暴"
	},
	{
		"id": 619,
		"type": 0,
		"school": 6,
		"icon": 1543,
		"describe": "【毁灭连爆】",
		"command": "/技能 毁灭连爆"
	},
	{
		"id": 620,
		"type": 0,
		"school": 6,
		"icon": 1544,
		"describe": "【爆裂流星·天火】",
		"command": "/技能 爆裂流星·天火"
	},
	{
		"id": 621,
		"type": 0,
		"school": 6,
		"icon": 1545,
		"describe": "【追命链狙·业火】",
		"command": "/技能 追命链狙·业火"
	},
	{
		"id": 622,
		"type": 0,
		"school": 6,
		"icon": 1562,
		"describe": "【黑铁·刀山】",
		"command": "/技能 黑铁·刀山"
	},
	{
		"id": 623,
		"type": 0,
		"school": 6,
		"icon": 1568,
		"describe": "【蓝钢·狱牙】",
		"command": "/技能 蓝钢·狱牙"
	},
	{
		"id": 624,
		"type": 0,
		"school": 6,
		"icon": 1569,
		"describe": "【利刃傀儡】",
		"command": "/技能 利刃傀儡"
	},
	{
		"id": 625,
		"type": 0,
		"school": 6,
		"icon": 1570,
		"describe": "【战争铁甲】",
		"command": "/技能 战争铁甲"
	},
	{
		"id": 626,
		"type": 0,
		"school": 6,
		"icon": 1563,
		"describe": "【灭屠战机】",
		"command": "/技能 灭屠战机"
	},
	{
		"id": 627,
		"type": 0,
		"school": 6,
		"icon": 1563,
		"describe": "【灭屠战机二段】",
		"command": "/技能 灭屠战机二段"
	},
	{
		"id": 701,
		"type": 0,
		"school": 7,
		"icon": 1401,
		"describe": "【灵击】",
		"command": "/技能 灵击"
	},
	{
		"id": 702,
		"type": 0,
		"school": 7,
		"icon": 1402,
		"describe": "【青鸟】",
		"command": "/技能 青鸟"
	},
	{
		"id": 703,
		"type": 0,
		"school": 7,
		"icon": 1402,
		"describe": "【青鸟二斩】",
		"command": "/技能 青鸟二斩"
	},
	{
		"id": 704,
		"type": 0,
		"school": 7,
		"icon": 1406,
		"describe": "【飞萤】",
		"command": "/技能 飞萤"
	},
	{
		"id": 705,
		"type": 0,
		"school": 7,
		"icon": 1411,
		"describe": "【春风】",
		"command": "/技能 春风"
	},
	{
		"id": 706,
		"type": 0,
		"school": 7,
		"icon": 1411,
		"describe": "【春风】（自我施法）",
		"command": "/技能 [自我施法] 春风"
	},
	{
		"id": 707,
		"type": 0,
		"school": 7,
		"icon": 1405,
		"describe": "【鱼跃】",
		"command": "/技能 鱼跃"
	},
	{
		"id": 708,
		"type": 0,
		"school": 7,
		"icon": 1405,
		"describe": "【鱼跃二斩】",
		"command": "/技能 鱼跃二斩"
	},
	{
		"id": 709,
		"type": 0,
		"school": 7,
		"icon": 1413,
		"describe": "【落樱】",
		"command": "/技能 落樱"
	},
	{
		"id": 710,
		"type": 0,
		"school": 7,
		"icon": 1413,
		"describe": "【落樱】（自我施法）",
		"command": "/技能 [自我施法] 落樱"
	},
	{
		"id": 711,
		"type": 0,
		"school": 7,
		"icon": 1412,
		"describe": "【青蔓】",
		"command": "/技能 青蔓"
	},
	{
		"id": 712,
		"type": 0,
		"school": 7,
		"icon": 1414,
		"describe": "【羽化】",
		"command": "/技能 羽化"
	},
	{
		"id": 713,
		"type": 0,
		"school": 7,
		"icon": 1414,
		"describe": "【羽化·灵】",
		"command": "/技能 羽化·灵"
	},
	{
		"id": 714,
		"type": 0,
		"school": 7,
		"icon": 1416,
		"describe": "【白露】",
		"command": "/技能 白露"
	},
	{
		"id": 715,
		"type": 0,
		"school": 7,
		"icon": 1416,
		"describe": "【白露】（自我施法）",
		"command": "/技能 [自我施法] 白露"
	},
	{
		"id": 716,
		"type": 0,
		"school": 7,
		"icon": 1404,
		"describe": "【灵化】",
		"command": "/技能 灵化"
	},
	{
		"id": 717,
		"type": 0,
		"school": 7,
		"icon": 1403,
		"describe": "【灵甲】",
		"command": "/技能 灵甲"
	},
	{
		"id": 718,
		"type": 0,
		"school": 7,
		"icon": 1403,
		"describe": "【灵甲】（自我施法）",
		"command": "/技能 [自我施法] 灵甲"
	},
	{
		"id": 719,
		"type": 0,
		"school": 7,
		"icon": 1403,
		"describe": "【灵甲二斩】",
		"command": "/技能 灵甲二斩"
	},
	{
		"id": 720,
		"type": 0,
		"school": 7,
		"icon": 1415,
		"describe": "【芊心】",
		"command": "/技能 芊心"
	},
	{
		"id": 721,
		"type": 0,
		"school": 7,
		"icon": 1447,
		"describe": "【鹿奔袭】",
		"command": "/技能 鹿奔袭"
	},
	{
		"id": 722,
		"type": 0,
		"school": 7,
		"icon": 1442,
		"describe": "【蛇缠藤】",
		"command": "/技能 蛇缠藤"
	},
	{
		"id": 723,
		"type": 0,
		"school": 7,
		"icon": 1441,
		"describe": "【鹰翼击】",
		"command": "/技能 鹰翼击"
	},
	{
		"id": 724,
		"type": 0,
		"school": 7,
		"icon": 1443,
		"describe": "【灵猿·啸空山】",
		"command": "/技能 灵猿·啸空山"
	},
	{
		"id": 725,
		"type": 0,
		"school": 7,
		"icon": 1462,
		"describe": "【月落甘霖】",
		"command": "/技能 月落甘霖"
	},
	{
		"id": 726,
		"type": 0,
		"school": 7,
		"icon": 1464,
		"describe": "【花游风间】",
		"command": "/技能 花游风间"
	},
	{
		"id": 727,
		"type": 0,
		"school": 7,
		"icon": 1464,
		"describe": "【花游风间】（自我施法）",
		"command": "/技能 [自我施法] 花游风间"
	},
	{
		"id": 728,
		"type": 0,
		"school": 7,
		"icon": 1461,
		"describe": "【花灵吐蕊】",
		"command": "/技能 花灵吐蕊"
	},
	{
		"id": 729,
		"type": 0,
		"school": 7,
		"icon": 1468,
		"describe": "【莲华·千叶舞】",
		"command": "/技能 莲华·千叶舞"
	},
	{
		"id": 730,
		"type": 0,
		"school": 7,
		"icon": 1463,
		"describe": "【灵佑·万物生】",
		"command": "/技能 灵佑·万物生"
	},
	{
		"id": 731,
		"type": 0,
		"school": 7,
		"icon": 1444,
		"describe": "【梦蝶·舞长天】",
		"command": "/技能 梦蝶·舞长天"
	},
	{
		"id": 801,
		"type": 0,
		"school": 8,
		"icon": 16022,
		"describe": "【魂击】",
		"command": "/技能 魂击"
	},
	{
		"id": 802,
		"type": 0,
		"school": 8,
		"icon": 16022,
		"describe": "【魂击】（自我施法）",
		"command": "/技能 [自我施法] 魂击"
	},
	{
		"id": 803,
		"type": 0,
		"school": 8,
		"icon": 16032,
		"describe": "【魂爆】",
		"command": "/技能 魂爆"
	},
	{
		"id": 804,
		"type": 0,
		"school": 8,
		"icon": 16032,
		"describe": "【魂爆】（自我施法）",
		"command": "/技能 [自我施法] 魂爆"
	},
	{
		"id": 805,
		"type": 0,
		"school": 8,
		"icon": 16152,
		"describe": "【魂珠】",
		"command": "/技能 魂珠"
	},
	{
		"id": 806,
		"type": 0,
		"school": 8,
		"icon": 16042,
		"describe": "【魂域】",
		"command": "/技能 魂域"
	},
	{
		"id": 807,
		"type": 0,
		"school": 8,
		"icon": 16062,
		"describe": "【追魂之魄】",
		"command": "/技能 追魂之魄"
	},
	{
		"id": 808,
		"type": 0,
		"school": 8,
		"icon": 16062,
		"describe": "【追魂之魄二斩】",
		"command": "/技能 追魂之魄二斩"
	},
	{
		"id": 809,
		"type": 0,
		"school": 8,
		"icon": 16112,
		"describe": "【魂镜】",
		"command": "/技能 魂镜"
	},
	{
		"id": 810,
		"type": 0,
		"school": 8,
		"icon": 16012,
		"describe": "【转魂】",
		"command": "/技能 转魂"
	},
	{
		"id": 811,
		"type": 0,
		"school": 8,
		"icon": 16142,
		"describe": "【破碎虚空】",
		"command": "/技能 破碎虚空"
	},
	{
		"id": 812,
		"type": 0,
		"school": 8,
		"icon": 16162,
		"describe": "【轮回之门】",
		"command": "/技能 轮回之门"
	},
	{
		"id": 813,
		"type": 0,
		"school": 8,
		"icon": 16052,
		"describe": "【离魂归位】",
		"command": "/技能 离魂归位"
	},
	{
		"id": 814,
		"type": 0,
		"school": 8,
		"icon": 16052,
		"describe": "【离魂归位二斩】",
		"command": "/技能 离魂归位二斩"
	},
	{
		"id": 815,
		"type": 0,
		"school": 8,
		"icon": 16132,
		"describe": "【灵魂之禁】",
		"command": "/技能 灵魂之禁"
	},
	{
		"id": 816,
		"type": 0,
		"school": 8,
		"icon": 16132,
		"describe": "【灵魂之禁】（自我施法）",
		"command": "/技能 [自我施法] 灵魂之禁"
	},
	{
		"id": 817,
		"type": 0,
		"school": 8,
		"icon": 16132,
		"describe": "【灵魂之禁二斩】",
		"command": "/技能 灵魂之禁二斩"
	},
	{
		"id": 818,
		"type": 0,
		"school": 8,
		"icon": 16122,
		"describe": "【虚空流转】",
		"command": "/技能 虚空流转"
	},
	{
		"id": 819,
		"type": 0,
		"school": 8,
		"icon": 1667,
		"describe": "【幽夜暗握】",
		"command": "/技能 幽夜暗握"
	},
	{
		"id": 820,
		"type": 0,
		"school": 8,
		"icon": 1662,
		"describe": "【死神过境】",
		"command": "/技能 死神过境"
	},
	{
		"id": 821,
		"type": 0,
		"school": 8,
		"icon": 1661,
		"describe": "【引魂离殇】",
		"command": "/技能 引魂离殇"
	},
	{
		"id": 822,
		"type": 0,
		"school": 8,
		"icon": 1668,
		"describe": "【一念堕魔】",
		"command": "/技能 一念堕魔"
	},
	{
		"id": 823,
		"type": 0,
		"school": 8,
		"icon": 1663,
		"describe": "【万魂俱寂】",
		"command": "/技能 万魂俱寂"
	},
	{
		"id": 824,
		"type": 0,
		"school": 8,
		"icon": 1646,
		"describe": "【极光之触】",
		"command": "/技能 极光之触"
	},
	{
		"id": 825,
		"type": 0,
		"school": 8,
		"icon": 1647,
		"describe": "【沐光之念】",
		"command": "/技能 沐光之念"
	},
	{
		"id": 826,
		"type": 0,
		"school": 8,
		"icon": 1641,
		"describe": "【涅槃之穹】",
		"command": "/技能 涅槃之穹"
	},
	{
		"id": 827,
		"type": 0,
		"school": 8,
		"icon": 1641,
		"describe": "【涅槃之穹】（自我施法）",
		"command": "/技能 [自我施法] 涅槃之穹"
	},
	{
		"id": 828,
		"type": 0,
		"school": 8,
		"icon": 1643,
		"describe": "【一念成神】",
		"command": "/技能 一念成神"
	},
	{
		"id": 829,
		"type": 0,
		"school": 8,
		"icon": 1645,
		"describe": "【移光引魂】",
		"command": "/技能 移光引魂"
	},
	{
		"id": 901,
		"type": 0,
		"school": 9,
		"icon": 1701,
		"describe": "【刃刺】",
		"command": "/技能 刃刺"
	},
	{
		"id": 902,
		"type": 0,
		"school": 9,
		"icon": 1701,
		"describe": "【刃刺二斩】",
		"command": "/技能 刃刺二斩"
	},
	{
		"id": 903,
		"type": 0,
		"school": 9,
		"icon": 1701,
		"describe": "【刃刺三斩】",
		"command": "/技能 刃刺三斩"
	},
	{
		"id": 904,
		"type": 0,
		"school": 9,
		"icon": 1701,
		"describe": "【刃刺四斩】",
		"command": "/技能 刃刺四斩"
	},
	{
		"id": 905,
		"type": 0,
		"school": 9,
		"icon": 1711,
		"describe": "【链击】",
		"command": "/技能 链击"
	},
	{
		"id": 906,
		"type": 0,
		"school": 9,
		"icon": 1711,
		"describe": "【链击二斩】",
		"command": "/技能 链击二斩"
	},
	{
		"id": 907,
		"type": 0,
		"school": 9,
		"icon": 1711,
		"describe": "【链击三斩】",
		"command": "/技能 链击三斩"
	},
	{
		"id": 908,
		"type": 0,
		"school": 9,
		"icon": 1711,
		"describe": "【链击四斩】",
		"command": "/技能 链击四斩"
	},
	{
		"id": 909,
		"type": 0,
		"school": 9,
		"icon": 1705,
		"describe": "【血刺】",
		"command": "/技能 血刺"
	},
	{
		"id": 910,
		"type": 0,
		"school": 9,
		"icon": 1716,
		"describe": "【毒体】",
		"command": "/技能 毒体"
	},
	{
		"id": 911,
		"type": 0,
		"school": 9,
		"icon": 1791,
		"describe": "【毒刃】",
		"command": "/技能 毒刃"
	},
	{
		"id": 912,
		"type": 0,
		"school": 9,
		"icon": 1713,
		"describe": "【链袭】",
		"command": "/技能 链袭"
	},
	{
		"id": 913,
		"type": 0,
		"school": 9,
		"icon": 1702,
		"describe": "【影杀】",
		"command": "/技能 影杀"
	},
	{
		"id": 914,
		"type": 0,
		"school": 9,
		"icon": 1714,
		"describe": "【潜影】",
		"command": "/技能 潜影"
	},
	{
		"id": 915,
		"type": 0,
		"school": 9,
		"icon": 1790,
		"describe": "【瞬影】",
		"command": "/技能 瞬影"
	},
	{
		"id": 916,
		"type": 0,
		"school": 9,
		"icon": 1715,
		"describe": "【链舞】",
		"command": "/技能 链舞"
	},
	{
		"id": 917,
		"type": 0,
		"school": 9,
		"icon": 1703,
		"describe": "【影袭】",
		"command": "/技能 影袭"
	},
	{
		"id": 918,
		"type": 0,
		"school": 9,
		"icon": 1712,
		"describe": "【链缚】",
		"command": "/技能 链缚"
	},
	{
		"id": 919,
		"type": 0,
		"school": 9,
		"icon": 1704,
		"describe": "【旋刃】",
		"command": "/技能 旋刃"
	},
	{
		"id": 920,
		"type": 0,
		"school": 9,
		"icon": 1706,
		"describe": "【疾影】",
		"command": "/技能 疾影"
	},
	{
		"id": 921,
		"type": 0,
		"school": 9,
		"icon": 1741,
		"describe": "【刃·致命】",
		"command": "/技能 刃·致命"
	},
	{
		"id": 922,
		"type": 0,
		"school": 9,
		"icon": 1742,
		"describe": "【化影·伏杀】",
		"command": "/技能 化影·伏杀"
	},
	{
		"id": 923,
		"type": 0,
		"school": 9,
		"icon": 1743,
		"describe": "【化影·绝杀】",
		"command": "/技能 化影·绝杀"
	},
	{
		"id": 924,
		"type": 0,
		"school": 9,
		"icon": 1745,
		"describe": "【戮·神灭】",
		"command": "/技能 戮·神灭"
	},
	{
		"id": 925,
		"type": 0,
		"school": 9,
		"icon": 1744,
		"describe": "【戮·神陨】",
		"command": "/技能 戮·神陨"
	},
	{
		"id": 926,
		"type": 0,
		"school": 9,
		"icon": 1761,
		"describe": "【链·囚罪】",
		"command": "/技能 链·囚罪"
	},
	{
		"id": 927,
		"type": 0,
		"school": 9,
		"icon": 1762,
		"describe": "【影·遁形】",
		"command": "/技能 影·遁形"
	},
	{
		"id": 928,
		"type": 0,
		"school": 9,
		"icon": 1763,
		"describe": "【化影·裂地】",
		"command": "/技能 化影·裂地"
	},
	{
		"id": 929,
		"type": 0,
		"school": 9,
		"icon": 1764,
		"describe": "【戮·神囚】",
		"command": "/技能 戮·神囚"
	},
	{
		"id": 930,
		"type": 0,
		"school": 9,
		"icon": 1765,
		"describe": "【追影·夺魂】",
		"command": "/技能 追影·夺魂"
	},
	{
		"id": 1000,
		"type": 0,
		"school": 0,
		"icon": 50001,
		"describe": "【英灵急呼】",
		"command": "/英灵技能 英灵急呼"
	},
	{
		"id": 1001,
		"type": 0,
		"school": 0,
		"icon": 50002,
		"describe": "【英灵觉醒技】",
		"command": "/英灵技能 英灵觉醒技"
	},
	{
		"id": 1101,
		"type": 0,
		"school": 10,
		"icon": 1901,
		"describe": "【月碎】",
		"command": "/技能 月碎"
	},
	{
		"id": 1102,
		"type": 0,
		"school": 10,
		"icon": 1901,
		"describe": "【月碎二斩】",
		"command": "/技能 月碎二斩"
	},
	{
		"id": 1103,
		"type": 0,
		"school": 10,
		"icon": 1901,
		"describe": "【月碎三斩】",
		"command": "/技能 月碎三斩"
	},
	{
		"id": 1104,
		"type": 0,
		"school": 10,
		"icon": 1901,
		"describe": "【月碎四斩】",
		"command": "/技能 月碎四斩"
	},
	{
		"id": 1105,
		"type": 0,
		"school": 10,
		"icon": 1902,
		"describe": "【鳞追】",
		"command": "/技能 鳞追"
	},
	{
		"id": 1106,
		"type": 0,
		"school": 10,
		"icon": 1904,
		"describe": "【剑·龙旋】",
		"command": "/技能 剑·龙旋"
	},
	{
		"id": 1107,
		"type": 0,
		"school": 10,
		"icon": 1905,
		"describe": "【剑·杀合】",
		"command": "/技能 剑·杀合"
	},
	{
		"id": 1108,
		"type": 0,
		"school": 10,
		"icon": 1907,
		"describe": "【凌突】",
		"command": "/技能 凌突"
	},
	{
		"id": 1109,
		"type": 0,
		"school": 10,
		"icon": 1907,
		"describe": "【凌突二斩】",
		"command": "/技能 凌突二斩"
	},
	{
		"id": 1110,
		"type": 0,
		"school": 10,
		"icon": 1906,
		"describe": "【风裂】",
		"command": "/技能 风裂"
	},
	{
		"id": 1111,
		"type": 0,
		"school": 10,
		"icon": 1906,
		"describe": "【风裂二斩】",
		"command": "/技能 风裂二斩"
	},
	{
		"id": 1112,
		"type": 0,
		"school": 10,
		"icon": 1908,
		"describe": "【化龙】",
		"command": "/技能 化龙"
	},
	{
		"id": 1113,
		"type": 0,
		"school": 10,
		"icon": 1903,
		"describe": "【龙·游世】",
		"command": "/技能 龙·游世"
	},
	{
		"id": 1114,
		"type": 0,
		"school": 10,
		"icon": 1909,
		"describe": "【龙·天返】",
		"command": "/技能 龙·天返"
	},
	{
		"id": 1115,
		"type": 0,
		"school": 10,
		"icon": 1909,
		"describe": "【龙·天返二斩】",
		"command": "/技能 龙·天返二斩"
	},
	{
		"id": 1116,
		"type": 0,
		"school": 10,
		"icon": 1910,
		"describe": "【英域】",
		"command": "/技能 英域"
	},
	{
		"id": 1117,
		"type": 0,
		"school": 10,
		"icon": 1911,
		"describe": "【剑·如龙】",
		"command": "/技能 剑·如龙"
	},
	{
		"id": 1118,
		"type": 0,
		"school": 10,
		"icon": 1912,
		"describe": "【龙·战甲】",
		"command": "/技能 龙·战甲"
	},
	{
		"id": 1119,
		"type": 0,
		"school": 10,
		"icon": 1913,
		"describe": "【剑曲·月华】",
		"command": "/技能 剑曲·月华"
	},
	{
		"id": 1120,
		"type": 0,
		"school": 10,
		"icon": 1914,
		"describe": "【剑啸·奔云】",
		"command": "/技能 剑啸·奔云"
	},
	{
		"id": 1121,
		"type": 0,
		"school": 10,
		"icon": 1914,
		"describe": "【剑啸·奔云二斩】",
		"command": "/技能 剑啸·奔云二斩"
	},
	{
		"id": 1122,
		"type": 0,
		"school": 10,
		"icon": 1916,
		"describe": "【剑啸·天绝】",
		"command": "/技能 剑啸·天绝"
	},
	{
		"id": 1123,
		"type": 0,
		"school": 10,
		"icon": 1917,
		"describe": "【剑指·湍流怒】",
		"command": "/技能 剑指·湍流怒"
	},
	{
		"id": 1124,
		"type": 0,
		"school": 10,
		"icon": 1915,
		"describe": "【剑怒·地龙威】",
		"command": "/技能 剑怒·地龙威"
	},
	{
		"id": 1125,
		"type": 0,
		"school": 10,
		"icon": 1918,
		"describe": "【龙吟·奔流】",
		"command": "/技能 龙吟·奔流"
	},
	{
		"id": 1126,
		"type": 0,
		"school": 10,
		"icon": 1919,
		"describe": "【龙吟·惊鳞】",
		"command": "/技能 龙吟·惊鳞"
	},
	{
		"id": 1127,
		"type": 0,
		"school": 10,
		"icon": 1920,
		"describe": "【龙吟·燃心】",
		"command": "/技能 龙吟·燃心"
	},
	{
		"id": 1128,
		"type": 0,
		"school": 10,
		"icon": 1921,
		"describe": "【龙耀·天击世】",
		"command": "/技能 龙耀·天击世"
	},
	{
		"id": 1129,
		"type": 0,
		"school": 10,
		"icon": 1921,
		"describe": "【龙耀·天击世二斩】",
		"command": "/技能 龙耀·天击世二斩"
	},
	{
		"id": 1130,
		"type": 0,
		"school": 10,
		"icon": 1922,
		"describe": "【龙律·时逆卷】",
		"command": "/技能 龙律·时逆卷"
	},
	{
		"id": 1201,
		"type": 0,
		"school": 11,
		"icon": 2110,
		"describe": "【翎击】",
		"command": "/技能 翎击"
	},
	{
		"id": 1202,
		"type": 0,
		"school": 11,
		"icon": 2110,
		"describe": "【翎击二斩】",
		"command": "/技能 翎击二斩"
	},
	{
		"id": 1203,
		"type": 0,
		"school": 11,
		"icon": 2110,
		"describe": "【翎击三斩】",
		"command": "/技能 翎击三斩"
	},
	{
		"id": 1204,
		"type": 0,
		"school": 11,
		"icon": 2110,
		"describe": "【翎击四斩】",
		"command": "/技能 翎击四斩"
	},
	{
		"id": 1205,
		"type": 0,
		"school": 11,
		"icon": 2114,
		"describe": "【天狩光轮】",
		"command": "/技能 天狩光轮"
	},
	{
		"id": 1206,
		"type": 0,
		"school": 11,
		"icon": 2115,
		"describe": "【破冥】",
		"command": "/技能 破冥"
	},
	{
		"id": 1207,
		"type": 0,
		"school": 11,
		"icon": 2116,
		"describe": "【锁厄】",
		"command": "/技能 锁厄"
	},
	{
		"id": 1208,
		"type": 0,
		"school": 11,
		"icon": 2117,
		"describe": "【鸿落】",
		"command": "/技能 鸿落"
	},
	{
		"id": 1209,
		"type": 0,
		"school": 11,
		"icon": 2118,
		"describe": "【风旋刃】",
		"command": "/技能 风旋刃"
	},
	{
		"id": 1210,
		"type": 0,
		"school": 11,
		"icon": 2119,
		"describe": "【裂穹斩】",
		"command": "/技能 裂穹斩"
	},
	{
		"id": 1211,
		"type": 0,
		"school": 11,
		"icon": 2120,
		"describe": "【帝·裂穹斩】",
		"command": "/技能 帝·裂穹斩"
	},
	{
		"id": 1212,
		"type": 0,
		"school": 11,
		"icon": 2121,
		"describe": "【华绽天羽】",
		"command": "/技能 华绽天羽"
	},
	{
		"id": 1213,
		"type": 0,
		"school": 11,
		"icon": 2122,
		"describe": "【光影瞬袭】",
		"command": "/技能 光影瞬袭"
	},
	{
		"id": 1214,
		"type": 0,
		"school": 11,
		"icon": 2123,
		"describe": "【呼啸深空】",
		"command": "/技能 呼啸深空"
	},
	{
		"id": 1215,
		"type": 0,
		"school": 11,
		"icon": 2124,
		"describe": "【同光凭神】",
		"command": "/技能 同光凭神"
	},
	{
		"id": 1216,
		"type": 0,
		"school": 11,
		"icon": 2125,
		"describe": "【镇光囚笼】",
		"command": "/技能 镇光囚笼"
	},
	{
		"id": 1217,
		"type": 0,
		"school": 11,
		"icon": 2126,
		"describe": "【帝·裁决再临】",
		"command": "/技能 帝·裁决再临"
	},
	{
		"id": 1218,
		"type": 0,
		"school": 11,
		"icon": 2127,
		"describe": "【惊鸿掠影】",
		"command": "/技能 惊鸿掠影"
	},
	{
		"id": 1219,
		"type": 0,
		"school": 11,
		"icon": 2129,
		"describe": "【翎羽绝阵】",
		"command": "/技能 翎羽绝阵"
	},
	{
		"id": 1220,
		"type": 0,
		"school": 11,
		"icon": 2130,
		"describe": "【帝·翎羽绝阵】",
		"command": "/技能 帝·翎羽绝阵"
	},
	{
		"id": 1221,
		"type": 0,
		"school": 11,
		"icon": 2131,
		"describe": "【天祈·旋光】",
		"command": "/技能 天祈·旋光"
	},
	{
		"id": 1222,
		"type": 0,
		"school": 11,
		"icon": 2131,
		"describe": "【天祈·旋光二斩】",
		"command": "/技能 天祈·旋光二斩"
	},
	{
		"id": 1223,
		"type": 0,
		"school": 11,
		"icon": 2132,
		"describe": "【天命·束身之矛】",
		"command": "/技能 天命·束身之矛"
	},
	{
		"id": 1224,
		"type": 0,
		"school": 11,
		"icon": 2133,
		"describe": "【天剑·徊刃】",
		"command": "/技能 天剑·徊刃"
	},
	{
		"id": 1225,
		"type": 0,
		"school": 11,
		"icon": 2133,
		"describe": "【天剑·徊刃二斩】",
		"command": "/技能 天剑·徊刃二斩"
	},
	{
		"id": 1226,
		"type": 0,
		"school": 11,
		"icon": 2134,
		"describe": "【天命·三重羽袭】",
		"command": "/技能 天命·三重羽袭"
	},
	{
		"id": 1227,
		"type": 0,
		"school": 11,
		"icon": 2135,
		"describe": "【天剑·撼斩】",
		"command": "/技能 天剑·撼斩"
	},
	{
		"id": 1228,
		"type": 0,
		"school": 11,
		"icon": 2136,
		"describe": "【神令·高天剑笼】",
		"command": "/技能 神令·高天剑笼"
	},
	{
		"id": 1229,
		"type": 0,
		"school": 11,
		"icon": 2137,
		"describe": "【神罚·曙光照夜】",
		"command": "/技能 神罚·曙光照夜"
	},
	{
		"id": 1230,
		"type": 0,
		"school": 11,
		"icon": 2138,
		"describe": "【神罚·天光凝锋】",
		"command": "/技能 神罚·天光凝锋"
	},
	{
		"id": 1231,
		"type": 0,
		"school": 11,
		"icon": 2139,
		"describe": "【神命·弥涅瓦之佑】",
		"command": "/技能 神命·弥涅瓦之佑"
	},
	{
		"id": 1232,
		"type": 0,
		"school": 11,
		"icon": 2140,
		"describe": "【神命·白帝之威临】",
		"command": "/技能 神命·白帝之威临"
	},
	{
		"id": 1233,
		"type": 0,
		"school": 11,
		"icon": 2140,
		"describe": "【消·白帝之威临】",
		"command": "/技能 消·白帝之威临"
	},
	{
		"id": 2000,
		"type": 1,
		"school": 0,
		"icon": 40749,
		"describe": "【蘑菇小酥】",
		"command": "/物品 蘑菇小酥"
	},
	{
		"id": 2001,
		"type": 1,
		"school": 0,
		"icon": 20130,
		"describe": "【蜂蜜布丁】",
		"command": "/物品 蜂蜜布丁"
	},
	{
		"id": 2002,
		"type": 1,
		"school": 0,
		"icon": 40756,
		"describe": "【樱花红豆羹】",
		"command": "/物品 樱花红豆羹"
	},
	{
		"id": 2003,
		"type": 1,
		"school": 0,
		"icon": 40745,
		"describe": "【祭海饮】",
		"command": "/物品 祭海饮"
	},
	{
		"id": 2004,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【澜江酿】",
		"command": "/物品 澜江酿"
	},
	{
		"id": 2005,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【活络散】",
		"command": "/物品 活络散"
	},
	{
		"id": 2006,
		"type": 1,
		"school": 0,
		"icon": 40156,
		"describe": "【椰子烈酒】",
		"command": "/物品 椰子烈酒"
	},
	{
		"id": 2007,
		"type": 1,
		"school": 0,
		"icon": 40764,
		"describe": "【西米桃浆】",
		"command": "/物品 西米桃浆"
	},
	{
		"id": 2008,
		"type": 1,
		"school": 0,
		"icon": 40175,
		"describe": "【圣品玉露丹】",
		"command": "/物品 圣品玉露丹"
	},
	{
		"id": 2009,
		"type": 1,
		"school": 0,
		"icon": 50114,
		"describe": "【凡品秘贴丹】",
		"command": "/物品 凡品秘贴丹"
	},
	{
		"id": 2010,
		"type": 1,
		"school": 0,
		"icon": 30508,
		"describe": "【精品秘贴丹】",
		"command": "/物品 精品秘贴丹"
	},
	{
		"id": 2011,
		"type": 1,
		"school": 0,
		"icon": 40689,
		"describe": "【圣品秘贴丹】",
		"command": "/物品 圣品秘贴丹"
	},
	{
		"id": 2012,
		"type": 1,
		"school": 0,
		"icon": 40682,
		"describe": "【凡品青麟丹】",
		"command": "/物品 凡品青麟丹"
	},
	{
		"id": 2013,
		"type": 1,
		"school": 0,
		"icon": 40690,
		"describe": "【精品青麟丹】",
		"command": "/物品 精品青麟丹"
	},
	{
		"id": 2014,
		"type": 1,
		"school": 0,
		"icon": 40755,
		"describe": "【明前甘露】",
		"command": "/物品 明前甘露"
	},
	{
		"id": 2015,
		"type": 1,
		"school": 0,
		"icon": 40156,
		"describe": "【新茶气津】",
		"command": "/物品 新茶气津"
	},
	{
		"id": 2016,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【雨前气津】",
		"command": "/物品 雨前气津"
	},
	{
		"id": 2017,
		"type": 1,
		"school": 0,
		"icon": 40747,
		"describe": "【明前气津】",
		"command": "/物品 明前气津"
	},
	{
		"id": 2018,
		"type": 1,
		"school": 0,
		"icon": 40737,
		"describe": "【新茶凝香】",
		"command": "/物品 新茶凝香"
	},
	{
		"id": 2019,
		"type": 1,
		"school": 0,
		"icon": 40757,
		"describe": "【雨前凝香】",
		"command": "/物品 雨前凝香"
	},
	{
		"id": 2020,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【星落酒】",
		"command": "/物品 星落酒"
	},
	{
		"id": 2021,
		"type": 1,
		"school": 0,
		"icon": 40661,
		"describe": "【天神酒】",
		"command": "/物品 天神酒"
	},
	{
		"id": 2022,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【杏花酿】",
		"command": "/物品 杏花酿"
	},
	{
		"id": 2023,
		"type": 1,
		"school": 0,
		"icon": 20105,
		"describe": "【仙菇药剂】",
		"command": "/物品 仙菇药剂"
	},
	{
		"id": 2024,
		"type": 1,
		"school": 0,
		"icon": 20161,
		"describe": "【永恒酒·初】",
		"command": "/物品 永恒酒·初"
	},
	{
		"id": 2025,
		"type": 1,
		"school": 0,
		"icon": 20162,
		"describe": "【轮回酿·初】",
		"command": "/物品 轮回酿·初"
	},
	{
		"id": 2026,
		"type": 1,
		"school": 0,
		"icon": 20165,
		"describe": "【混沌饮·初】",
		"command": "/物品 混沌饮·初"
	},
	{
		"id": 2027,
		"type": 1,
		"school": 0,
		"icon": 20161,
		"describe": "【永恒酒·高】",
		"command": "/物品 永恒酒·高"
	},
	{
		"id": 2028,
		"type": 1,
		"school": 0,
		"icon": 20162,
		"describe": "【轮回酿·高】",
		"command": "/物品 轮回酿·高"
	},
	{
		"id": 2029,
		"type": 1,
		"school": 0,
		"icon": 20165,
		"describe": "【混沌饮·高】",
		"command": "/物品 混沌饮·高"
	},
	{
		"id": 2030,
		"type": 1,
		"school": 0,
		"icon": 20165,
		"describe": "【天怒饮】",
		"command": "/物品 天怒饮"
	},
	{
		"id": 2031,
		"type": 1,
		"school": 0,
		"icon": 40825,
		"describe": "【微弱火元素】",
		"command": "/物品 微弱火元素"
	},
	{
		"id": 2032,
		"type": 1,
		"school": 0,
		"icon": 40825,
		"describe": "【中性火元素】",
		"command": "/物品 中性火元素"
	},
	{
		"id": 2033,
		"type": 1,
		"school": 0,
		"icon": 40825,
		"describe": "【烈性火元素】",
		"command": "/物品 烈性火元素"
	},
	{
		"id": 2034,
		"type": 1,
		"school": 0,
		"icon": 40825,
		"describe": "【微弱赤炎元素】",
		"command": "/物品 微弱赤炎元素"
	},
	{
		"id": 2035,
		"type": 1,
		"school": 0,
		"icon": 40825,
		"describe": "【中性赤炎元素】",
		"command": "/物品 中性赤炎元素"
	},
	{
		"id": 2036,
		"type": 1,
		"school": 0,
		"icon": 40823,
		"describe": "【微弱水元素】",
		"command": "/物品 微弱水元素"
	},
	{
		"id": 2037,
		"type": 1,
		"school": 0,
		"icon": 40823,
		"describe": "【中性水元素】",
		"command": "/物品 中性水元素"
	},
	{
		"id": 2038,
		"type": 1,
		"school": 0,
		"icon": 40823,
		"describe": "【烈性水元素】",
		"command": "/物品 烈性水元素"
	},
	{
		"id": 2039,
		"type": 1,
		"school": 0,
		"icon": 40823,
		"describe": "【微弱碧波元素】",
		"command": "/物品 微弱碧波元素"
	},
	{
		"id": 2040,
		"type": 1,
		"school": 0,
		"icon": 40823,
		"describe": "【中性碧波元素】",
		"command": "/物品 中性碧波元素"
	},
	{
		"id": 2041,
		"type": 1,
		"school": 0,
		"icon": 40819,
		"describe": "【微弱金元素】",
		"command": "/物品 微弱金元素"
	},
	{
		"id": 2042,
		"type": 1,
		"school": 0,
		"icon": 40819,
		"describe": "【中性金元素】",
		"command": "/物品 中性金元素"
	},
	{
		"id": 2043,
		"type": 1,
		"school": 0,
		"icon": 40819,
		"describe": "【烈性金元素】",
		"command": "/物品 烈性金元素"
	},
	{
		"id": 2044,
		"type": 1,
		"school": 0,
		"icon": 40819,
		"describe": "【微弱疾影元素】",
		"command": "/物品 微弱疾影元素"
	},
	{
		"id": 2045,
		"type": 1,
		"school": 0,
		"icon": 40819,
		"describe": "【中性疾影元素】",
		"command": "/物品 中性疾影元素"
	},
	{
		"id": 2046,
		"type": 1,
		"school": 0,
		"icon": 40821,
		"describe": "【微弱土元素】",
		"command": "/物品 微弱土元素"
	},
	{
		"id": 2047,
		"type": 1,
		"school": 0,
		"icon": 40821,
		"describe": "【中性土元素】",
		"command": "/物品 中性土元素"
	},
	{
		"id": 2048,
		"type": 1,
		"school": 0,
		"icon": 40821,
		"describe": "【烈性土元素】",
		"command": "/物品 烈性土元素"
	},
	{
		"id": 2049,
		"type": 1,
		"school": 0,
		"icon": 40821,
		"describe": "【微弱坚石元素】",
		"command": "/物品 微弱坚石元素"
	},
	{
		"id": 2050,
		"type": 1,
		"school": 0,
		"icon": 40821,
		"describe": "【中性坚石元素】",
		"command": "/物品 中性坚石元素"
	},
	{
		"id": 2051,
		"type": 1,
		"school": 0,
		"icon": 40816,
		"describe": "【微弱木元素】",
		"command": "/物品 微弱木元素"
	},
	{
		"id": 2052,
		"type": 1,
		"school": 0,
		"icon": 40816,
		"describe": "【中性木元素】",
		"command": "/物品 中性木元素"
	},
	{
		"id": 2053,
		"type": 1,
		"school": 0,
		"icon": 40816,
		"describe": "【烈性木元素】",
		"command": "/物品 烈性木元素"
	},
	{
		"id": 2054,
		"type": 1,
		"school": 0,
		"icon": 40816,
		"describe": "【微弱元灵元素】",
		"command": "/物品 微弱元灵元素"
	},
	{
		"id": 2055,
		"type": 1,
		"school": 0,
		"icon": 40816,
		"describe": "【中性元灵元素】",
		"command": "/物品 中性元灵元素"
	},
	{
		"id": 2056,
		"type": 1,
		"school": 0,
		"icon": 40707,
		"describe": "【凡品乾金药剂】",
		"command": "/物品 凡品乾金药剂"
	},
	{
		"id": 2057,
		"type": 1,
		"school": 0,
		"icon": 40707,
		"describe": "【精品乾金药剂】",
		"command": "/物品 精品乾金药剂"
	},
	{
		"id": 2058,
		"type": 1,
		"school": 0,
		"icon": 40707,
		"describe": "【圣品乾金药剂】",
		"command": "/物品 圣品乾金药剂"
	},
	{
		"id": 2059,
		"type": 1,
		"school": 0,
		"icon": 40707,
		"describe": "【凡品坤木药剂】",
		"command": "/物品 凡品坤木药剂"
	},
	{
		"id": 2060,
		"type": 1,
		"school": 0,
		"icon": 40707,
		"describe": "【精品坤木药剂】",
		"command": "/物品 精品坤木药剂"
	},
	{
		"id": 2061,
		"type": 1,
		"school": 0,
		"icon": 40708,
		"describe": "【凡品静心药剂】",
		"command": "/物品 凡品静心药剂"
	},
	{
		"id": 2062,
		"type": 1,
		"school": 0,
		"icon": 40708,
		"describe": "【精品静心药剂】",
		"command": "/物品 精品静心药剂"
	},
	{
		"id": 2063,
		"type": 1,
		"school": 0,
		"icon": 40708,
		"describe": "【圣品静心药剂】",
		"command": "/物品 圣品静心药剂"
	},
	{
		"id": 2064,
		"type": 1,
		"school": 0,
		"icon": 40708,
		"describe": "【凡品凝神药剂】",
		"command": "/物品 凡品凝神药剂"
	},
	{
		"id": 2065,
		"type": 1,
		"school": 0,
		"icon": 40708,
		"describe": "【精品凝神药剂】",
		"command": "/物品 精品凝神药剂"
	},
	{
		"id": 2066,
		"type": 1,
		"school": 0,
		"icon": 40710,
		"describe": "【凡品强力药剂】",
		"command": "/物品 凡品强力药剂"
	},
	{
		"id": 2067,
		"type": 1,
		"school": 0,
		"icon": 40710,
		"describe": "【精品强力药剂】",
		"command": "/物品 精品强力药剂"
	},
	{
		"id": 2068,
		"type": 1,
		"school": 0,
		"icon": 40710,
		"describe": "【圣品强力药剂】",
		"command": "/物品 圣品强力药剂"
	},
	{
		"id": 2069,
		"type": 1,
		"school": 0,
		"icon": 40710,
		"describe": "【凡品离火药剂】",
		"command": "/物品 凡品离火药剂"
	},
	{
		"id": 2070,
		"type": 1,
		"school": 0,
		"icon": 40710,
		"describe": "【精品离火药剂】",
		"command": "/物品 精品离火药剂"
	},
	{
		"id": 2071,
		"type": 1,
		"school": 0,
		"icon": 40711,
		"describe": "【凡品启智药剂】",
		"command": "/物品 凡品启智药剂"
	},
	{
		"id": 2072,
		"type": 1,
		"school": 0,
		"icon": 40711,
		"describe": "【精品启智药剂】",
		"command": "/物品 精品启智药剂"
	},
	{
		"id": 2073,
		"type": 1,
		"school": 0,
		"icon": 40711,
		"describe": "【圣品启智药剂】",
		"command": "/物品 圣品启智药剂"
	},
	{
		"id": 2074,
		"type": 1,
		"school": 0,
		"icon": 40711,
		"describe": "【凡品睿智药剂】",
		"command": "/物品 凡品睿智药剂"
	},
	{
		"id": 2075,
		"type": 1,
		"school": 0,
		"icon": 40711,
		"describe": "【精品睿智药剂】",
		"command": "/物品 精品睿智药剂"
	},
	{
		"id": 2076,
		"type": 1,
		"school": 0,
		"icon": 40719,
		"describe": "【凡品暴烈药剂】",
		"command": "/物品 凡品暴烈药剂"
	},
	{
		"id": 2077,
		"type": 1,
		"school": 0,
		"icon": 40719,
		"describe": "【精品暴烈药剂】",
		"command": "/物品 精品暴烈药剂"
	},
	{
		"id": 2078,
		"type": 1,
		"school": 0,
		"icon": 40719,
		"describe": "【圣品暴烈药剂】",
		"command": "/物品 圣品暴烈药剂"
	},
	{
		"id": 2079,
		"type": 1,
		"school": 0,
		"icon": 40719,
		"describe": "【凡品雷吼药剂】",
		"command": "/物品 凡品雷吼药剂"
	},
	{
		"id": 2080,
		"type": 1,
		"school": 0,
		"icon": 40719,
		"describe": "【精品雷吼药剂】",
		"command": "/物品 精品雷吼药剂"
	},
	{
		"id": 2081,
		"type": 1,
		"school": 0,
		"icon": 40720,
		"describe": "【凡品锐气药剂】",
		"command": "/物品 凡品锐气药剂"
	},
	{
		"id": 2082,
		"type": 1,
		"school": 0,
		"icon": 40720,
		"describe": "【精品锐气药剂】",
		"command": "/物品 精品锐气药剂"
	},
	{
		"id": 2083,
		"type": 1,
		"school": 0,
		"icon": 40720,
		"describe": "【圣品锐气药剂】",
		"command": "/物品 圣品锐气药剂"
	},
	{
		"id": 2084,
		"type": 1,
		"school": 0,
		"icon": 40720,
		"describe": "【凡品震怒药剂】",
		"command": "/物品 凡品震怒药剂"
	},
	{
		"id": 2085,
		"type": 1,
		"school": 0,
		"icon": 40720,
		"describe": "【精品震怒药剂】",
		"command": "/物品 精品震怒药剂"
	},
	{
		"id": 2086,
		"type": 1,
		"school": 0,
		"icon": 40685,
		"describe": "【凡品锐眼药剂】",
		"command": "/物品 凡品锐眼药剂"
	},
	{
		"id": 2087,
		"type": 1,
		"school": 0,
		"icon": 40685,
		"describe": "【精品锐眼药剂】",
		"command": "/物品 精品锐眼药剂"
	},
	{
		"id": 2088,
		"type": 1,
		"school": 0,
		"icon": 40685,
		"describe": "【圣品锐眼药剂】",
		"command": "/物品 圣品锐眼药剂"
	},
	{
		"id": 2089,
		"type": 1,
		"school": 0,
		"icon": 40685,
		"describe": "【凡品精准药剂】",
		"command": "/物品 凡品精准药剂"
	},
	{
		"id": 2090,
		"type": 1,
		"school": 0,
		"icon": 40685,
		"describe": "【精品精准药剂】",
		"command": "/物品 精品精准药剂"
	},
	{
		"id": 2091,
		"type": 1,
		"school": 0,
		"icon": 40709,
		"describe": "【凡品兑泽药剂】",
		"command": "/物品 凡品兑泽药剂"
	},
	{
		"id": 2092,
		"type": 1,
		"school": 0,
		"icon": 40709,
		"describe": "【精品兑泽药剂】",
		"command": "/物品 精品兑泽药剂"
	},
	{
		"id": 2093,
		"type": 1,
		"school": 0,
		"icon": 40709,
		"describe": "【圣品兑泽药剂】",
		"command": "/物品 圣品兑泽药剂"
	},
	{
		"id": 2094,
		"type": 1,
		"school": 0,
		"icon": 40709,
		"describe": "【凡品艮山药剂】",
		"command": "/物品 凡品艮山药剂"
	},
	{
		"id": 2095,
		"type": 1,
		"school": 0,
		"icon": 40709,
		"describe": "【精品艮山药剂】",
		"command": "/物品 精品艮山药剂"
	},
	{
		"id": 2096,
		"type": 1,
		"school": 0,
		"icon": 306401,
		"describe": "【杂鱼菜汤】",
		"command": "/物品 杂鱼菜汤"
	},
	{
		"id": 2097,
		"type": 1,
		"school": 0,
		"icon": 306402,
		"describe": "【肉夹馍】",
		"command": "/物品 肉夹馍"
	},
	{
		"id": 2098,
		"type": 1,
		"school": 0,
		"icon": 40726,
		"describe": "【鱼脊炖豆腐】",
		"command": "/物品 鱼脊炖豆腐"
	},
	{
		"id": 2099,
		"type": 1,
		"school": 0,
		"icon": 306404,
		"describe": "【银月刺身】",
		"command": "/物品 银月刺身"
	},
	{
		"id": 2100,
		"type": 1,
		"school": 0,
		"icon": 306405,
		"describe": "【精炖灵鱼羹】",
		"command": "/物品 精炖灵鱼羹"
	},
	{
		"id": 2101,
		"type": 1,
		"school": 0,
		"icon": 306411,
		"describe": "【香酥鱼排】",
		"command": "/物品 香酥鱼排"
	},
	{
		"id": 2102,
		"type": 1,
		"school": 0,
		"icon": 306412,
		"describe": "【一点红砂锅】",
		"command": "/物品 一点红砂锅"
	},
	{
		"id": 2103,
		"type": 1,
		"school": 0,
		"icon": 306413,
		"describe": "【清蒸娃娃鱼】",
		"command": "/物品 清蒸娃娃鱼"
	},
	{
		"id": 2104,
		"type": 1,
		"school": 0,
		"icon": 306414,
		"describe": "【香菇鸡肉嫩鱼汤】",
		"command": "/物品 香菇鸡肉嫩鱼汤"
	},
	{
		"id": 2105,
		"type": 1,
		"school": 0,
		"icon": 306415,
		"describe": "【果木烤猪腿】",
		"command": "/物品 果木烤猪腿"
	},
	{
		"id": 2106,
		"type": 1,
		"school": 0,
		"icon": 40733,
		"describe": "【老参炖鸡汤】",
		"command": "/物品 老参炖鸡汤"
	},
	{
		"id": 2107,
		"type": 1,
		"school": 0,
		"icon": 306432,
		"describe": "【水晶鱼翅羹】",
		"command": "/物品 水晶鱼翅羹"
	},
	{
		"id": 2108,
		"type": 1,
		"school": 0,
		"icon": 306433,
		"describe": "【葱姜啤酒鸡】",
		"command": "/物品 葱姜啤酒鸡"
	},
	{
		"id": 2109,
		"type": 1,
		"school": 0,
		"icon": 306434,
		"describe": "【天麻猪脑汤】",
		"command": "/物品 天麻猪脑汤"
	},
	{
		"id": 2110,
		"type": 1,
		"school": 0,
		"icon": 306435,
		"describe": "【悲风原汁鲟鱼汤】",
		"command": "/物品 悲风原汁鲟鱼汤"
	},
	{
		"id": 2111,
		"type": 1,
		"school": 0,
		"icon": 40698,
		"describe": "【砥石鸡公煲】",
		"command": "/物品 砥石鸡公煲"
	},
	{
		"id": 2112,
		"type": 1,
		"school": 0,
		"icon": 40694,
		"describe": "【浓香大骨汤】",
		"command": "/物品 浓香大骨汤"
	},
	{
		"id": 2113,
		"type": 1,
		"school": 0,
		"icon": 306443,
		"describe": "【酒香麻辣猪肉煲】",
		"command": "/物品 酒香麻辣猪肉煲"
	},
	{
		"id": 2114,
		"type": 1,
		"school": 0,
		"icon": 306444,
		"describe": "【旗鱼三吃】",
		"command": "/物品 旗鱼三吃"
	},
	{
		"id": 2115,
		"type": 1,
		"school": 0,
		"icon": 306445,
		"describe": "【劲辣蜜汁羊腿】",
		"command": "/物品 劲辣蜜汁羊腿"
	},
	{
		"id": 2116,
		"type": 1,
		"school": 0,
		"icon": 306451,
		"describe": "【苏澜炒饭】",
		"command": "/物品 苏澜炒饭"
	},
	{
		"id": 2117,
		"type": 1,
		"school": 0,
		"icon": 40718,
		"describe": "【菌王汤】",
		"command": "/物品 菌王汤"
	},
	{
		"id": 2118,
		"type": 1,
		"school": 0,
		"icon": 306453,
		"describe": "【万家灯火】",
		"command": "/物品 万家灯火"
	},
	{
		"id": 2119,
		"type": 1,
		"school": 0,
		"icon": 306454,
		"describe": "【山之珍】",
		"command": "/物品 山之珍"
	},
	{
		"id": 2120,
		"type": 1,
		"school": 0,
		"icon": 306455,
		"describe": "【剁椒鱼头】",
		"command": "/物品 剁椒鱼头"
	},
	{
		"id": 2121,
		"type": 1,
		"school": 0,
		"icon": 306461,
		"describe": "【肥牛盖浇饭】",
		"command": "/物品 肥牛盖浇饭"
	},
	{
		"id": 2122,
		"type": 1,
		"school": 0,
		"icon": 306462,
		"describe": "【卤煮火烧】",
		"command": "/物品 卤煮火烧"
	},
	{
		"id": 2123,
		"type": 1,
		"school": 0,
		"icon": 306463,
		"describe": "【千层鱼肉酥】",
		"command": "/物品 千层鱼肉酥"
	},
	{
		"id": 2124,
		"type": 1,
		"school": 0,
		"icon": 306464,
		"describe": "【海之味】",
		"command": "/物品 海之味"
	},
	{
		"id": 2125,
		"type": 1,
		"school": 0,
		"icon": 306465,
		"describe": "【狂野腊肉】",
		"command": "/物品 狂野腊肉"
	},
	{
		"id": 2126,
		"type": 1,
		"school": 0,
		"icon": 306421,
		"describe": "【鳗鱼笋汤】",
		"command": "/物品 鳗鱼笋汤"
	},
	{
		"id": 2127,
		"type": 1,
		"school": 0,
		"icon": 306422,
		"describe": "【铁板鱿鱼】",
		"command": "/物品 铁板鱿鱼"
	},
	{
		"id": 2128,
		"type": 1,
		"school": 0,
		"icon": 306423,
		"describe": "【蒜香白肉】",
		"command": "/物品 蒜香白肉"
	},
	{
		"id": 2129,
		"type": 1,
		"school": 0,
		"icon": 306424,
		"describe": "【生炒鲶须】",
		"command": "/物品 生炒鲶须"
	},
	{
		"id": 2130,
		"type": 1,
		"school": 0,
		"icon": 306425,
		"describe": "【土豆炖牛肉】",
		"command": "/物品 土豆炖牛肉"
	},
	{
		"id": 2131,
		"type": 1,
		"school": 0,
		"icon": 40750,
		"describe": "【新酿灵龟酒】",
		"command": "/物品 新酿灵龟酒"
	},
	{
		"id": 2132,
		"type": 1,
		"school": 0,
		"icon": 40750,
		"describe": "【佳酿灵龟酒】",
		"command": "/物品 佳酿灵龟酒"
	},
	{
		"id": 2133,
		"type": 1,
		"school": 0,
		"icon": 40750,
		"describe": "【百年灵龟酒】",
		"command": "/物品 百年灵龟酒"
	},
	{
		"id": 2134,
		"type": 1,
		"school": 0,
		"icon": 40750,
		"describe": "【新酿金刚酒】",
		"command": "/物品 新酿金刚酒"
	},
	{
		"id": 2135,
		"type": 1,
		"school": 0,
		"icon": 40750,
		"describe": "【佳酿金刚酒】",
		"command": "/物品 佳酿金刚酒"
	},
	{
		"id": 2136,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【新酿虎骨酒】",
		"command": "/物品 新酿虎骨酒"
	},
	{
		"id": 2137,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【佳酿虎骨酒】",
		"command": "/物品 佳酿虎骨酒"
	},
	{
		"id": 2138,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【百年虎骨酒】",
		"command": "/物品 百年虎骨酒"
	},
	{
		"id": 2139,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【新酿铁骑酒】",
		"command": "/物品 新酿铁骑酒"
	},
	{
		"id": 2140,
		"type": 1,
		"school": 0,
		"icon": 40752,
		"describe": "【佳酿铁骑酒】",
		"command": "/物品 佳酿铁骑酒"
	},
	{
		"id": 2141,
		"type": 1,
		"school": 0,
		"icon": 40753,
		"describe": "【新酿西风列酒】",
		"command": "/物品 新酿西风列酒"
	},
	{
		"id": 2142,
		"type": 1,
		"school": 0,
		"icon": 40753,
		"describe": "【佳酿西风列酒】",
		"command": "/物品 佳酿西风列酒"
	},
	{
		"id": 2143,
		"type": 1,
		"school": 0,
		"icon": 40753,
		"describe": "【百年西风列酒】",
		"command": "/物品 百年西风列酒"
	},
	{
		"id": 2144,
		"type": 1,
		"school": 0,
		"icon": 40753,
		"describe": "【新酿金戈酒】",
		"command": "/物品 新酿金戈酒"
	},
	{
		"id": 2145,
		"type": 1,
		"school": 0,
		"icon": 40753,
		"describe": "【佳酿金戈酒】",
		"command": "/物品 佳酿金戈酒"
	},
	{
		"id": 2146,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【新酿虎啸酒】",
		"command": "/物品 新酿虎啸酒"
	},
	{
		"id": 2147,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【佳酿虎啸酒】",
		"command": "/物品 佳酿虎啸酒"
	},
	{
		"id": 2148,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【百年虎啸酒】",
		"command": "/物品 百年虎啸酒"
	},
	{
		"id": 2149,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【新酿龙吟酒】",
		"command": "/物品 新酿龙吟酒"
	},
	{
		"id": 2150,
		"type": 1,
		"school": 0,
		"icon": 40748,
		"describe": "【佳酿龙吟酒】",
		"command": "/物品 佳酿龙吟酒"
	},
	{
		"id": 2151,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【新酿破阵酒】",
		"command": "/物品 新酿破阵酒"
	},
	{
		"id": 2152,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【佳酿破阵酒】",
		"command": "/物品 佳酿破阵酒"
	},
	{
		"id": 2153,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【百年破阵酒】",
		"command": "/物品 百年破阵酒"
	},
	{
		"id": 2154,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【新酿铁靴酒】",
		"command": "/物品 新酿铁靴酒"
	},
	{
		"id": 2155,
		"type": 1,
		"school": 0,
		"icon": 40751,
		"describe": "【佳酿铁靴酒】",
		"command": "/物品 佳酿铁靴酒"
	},
	{
		"id": 2156,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【新酿霜雪明酒】",
		"command": "/物品 新酿霜雪明酒"
	},
	{
		"id": 2157,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【佳酿霜雪明酒】",
		"command": "/物品 佳酿霜雪明酒"
	},
	{
		"id": 2158,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【百年霜雪明酒】",
		"command": "/物品 百年霜雪明酒"
	},
	{
		"id": 2159,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【新酿流云破酒】",
		"command": "/物品 新酿流云破酒"
	},
	{
		"id": 2160,
		"type": 1,
		"school": 0,
		"icon": 40754,
		"describe": "【佳酿流云破酒】",
		"command": "/物品 佳酿流云破酒"
	},
	{
		"id": 2161,
		"type": 1,
		"school": 0,
		"icon": 40738,
		"describe": "【新酿无妄酒】",
		"command": "/物品 新酿无妄酒"
	},
	{
		"id": 2162,
		"type": 1,
		"school": 0,
		"icon": 40738,
		"describe": "【佳酿无妄酒】",
		"command": "/物品 佳酿无妄酒"
	},
	{
		"id": 2163,
		"type": 1,
		"school": 0,
		"icon": 40738,
		"describe": "【百年无妄酒】",
		"command": "/物品 百年无妄酒"
	},
	{
		"id": 2164,
		"type": 1,
		"school": 0,
		"icon": 40738,
		"describe": "【新酿无虚酒】",
		"command": "/物品 新酿无虚酒"
	},
	{
		"id": 2165,
		"type": 1,
		"school": 0,
		"icon": 40738,
		"describe": "【佳酿无虚酒】",
		"command": "/物品 佳酿无虚酒"
	},
	{
		"id": 3002,
		"type": 2,
		"school": 0,
		"icon": "1002",
		"describe": "【怒】",
		"command": "/动作 怒"
	},
	{
		"id": 3003,
		"type": 2,
		"school": 0,
		"icon": "1003",
		"describe": "【流汗】",
		"command": "/动作 流汗"
	},
	{
		"id": 3004,
		"type": 2,
		"school": 0,
		"icon": "1004",
		"describe": "【无语】",
		"command": "/动作 无语"
	},
	{
		"id": 3005,
		"type": 2,
		"school": 0,
		"icon": "1005",
		"describe": "【示爱】",
		"command": "/动作 示爱"
	},
	{
		"id": 3006,
		"type": 2,
		"school": 0,
		"icon": "1006",
		"describe": "【吃惊】",
		"command": "/动作 吃惊"
	},
	{
		"id": 3007,
		"type": 2,
		"school": 0,
		"icon": "1007",
		"describe": "【心碎】",
		"command": "/动作 心碎"
	},
	{
		"id": 3008,
		"type": 2,
		"school": 0,
		"icon": "general_1001",
		"describe": "【骑乘】",
		"command": "/动作 骑乘"
	},
	{
		"id": 3009,
		"type": 2,
		"school": 0,
		"icon": "general_2001",
		"describe": "【展翅】",
		"command": "/动作 展翅"
	},
	{
		"id": 4002,
		"type": 3,
		"school": 0,
		"icon": 37,
		"describe": "【附近频道】喊话",
		"command": "/喊话 附近 喊话内容"
	},
	{
		"id": 4005,
		"type": 3,
		"school": 0,
		"icon": 37,
		"describe": "【队伍频道】喊话",
		"command": "/喊话 队伍 喊话内容"
	},
	{
		"id": 4006,
		"type": 3,
		"school": 0,
		"icon": 37,
		"describe": "【团队频道】喊话",
		"command": "/喊话 团队 喊话内容"
	}
];
module.exports=skillData;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/skillData.js
// module id = 9
// module chunks = 0 1 3 4